import { all, call, put, takeLatest } from 'redux-saga/effects';
import { Inventory } from 'actions/actionTypes';
import * as actions from 'actions/inventory/list';
import { callInventory } from 'network/apis/inventory/list';

function* loadInventoryListRequestSaga() {
    try{
        const response = yield call(callInventory);

        yield put(actions.loadInventoryListSuccess(response.data))
    }
    catch(error){
        yield put(actions.loadInventoryListFailure(error.messgae))
    }
}

export default function* root(){
    yield all([
        takeLatest(Inventory.LOAD_INVENTORY_LIST_REQUEST, loadInventoryListRequestSaga)
    ]);
}